import React from "react";
import Navbar from "../Navbar/Navbar";
import projectData from "../Data/ProjectsData";
import AnimationBackground from "../AnimatedBackground/AnimatedBackground";
import { useState } from "react";
import Projects from "../Projects/Projects";

const MoreProjects = () => {
  const [projects] = useState(projectData);
  return (
    <>
      <Navbar />
      <div style={{ height: "0" }}>
        <AnimationBackground />
      </div>
      <div className="container mb-5">
        <div className="project-gallery-header-text pt-5">
          <h1 className="text-center text-white font-weight-bold mb-5 pb-5">
            My Recent Projects
          </h1>
        </div>
        <div className="row d-flex justify-content-around">
          {projects.map((project) => (
            <Projects project={project} key={project.id} />
          ))}
        </div>
      </div>
    </>
  );
};

export default MoreProjects;
